import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_COASTAL_SEGMENTS_EVALUATION",
    parentId: "PILOT_COASTAL_SEGMENTS_VIEWS",
    applicationRights: Rights,
    title: 'Evaluering',
    text: 'Evaluer sertifikatomr&aring;der',
    icon: 'note-pencil',
    minWidth: 768,
    sequenceNo: 2000,
    url: "/pcs/EVALUATIONS"
})
